import React from 'react';
import { Button, PageContainer } from '../../../components/common';
import { ELEMENT_IDS } from '../../../constants/ids';
import { MdEdit } from 'react-icons/md';
import './reviewCartDefault.css';

const mockData = {
  serviceAddress: '1963 Winding Creek Road DR, Walterboro, SC, 120168',
  mailingAddress: '1963 Winding Creek Road DR, Walterboro, SC, 120168',
  planName: 'Internet Service 250/250',
  planTag: 'Internet Services',
  planPrice: '$89.95',
  addonName: 'WI-FI Mesh Extender',
  addonPrice: '$3.95',
  installDate:
    '✓ Our technician will arrive on July 4, 2025 10:00 AM CDT to install your service.',
  modemRental: '$0.00',
  tax: '$0.00',
  discount: '-$0.00',
  orderTotal: '$102.17',
};

const ReviewCartDefault = ({
  onAutoPayChange,
  onPaperlessChange,
  onProceedToTerms,
}) => {
  const [autoPayEnabled, setAutoPayEnabled] = React.useState(true);
  const [paperlessEnabled, setPaperlessEnabled] = React.useState(true);
  const [currentDiscount, setCurrentDiscount] = React.useState(10);

  const handleAutoPayChange = (e) => {
    const newValue = e.target.value === 'yes';
    console.log('AutoPay changed to:', newValue);
    setAutoPayEnabled(newValue);

    // Notify parent component
    if (onAutoPayChange) {
      onAutoPayChange(newValue);
    }
  };

  const handlePaperlessChange = (e) => {
    const newValue = e.target.value === 'yes';
    console.log('Paperless changed to:', newValue);
    setPaperlessEnabled(newValue);

    // Notify parent component
    if (onPaperlessChange) {
      onPaperlessChange(newValue);
    }
  };

  // Update discount whenever autopay or paperless changes
  React.useEffect(() => {
    let discount = 0;
    if (autoPayEnabled) discount += 5;
    if (paperlessEnabled) discount += 5;
    setCurrentDiscount(discount);
    console.log(
      '🔄 Discount updated - AutoPay:',
      autoPayEnabled,
      'Paperless:',
      paperlessEnabled,
      'Discount:',
      discount
    );
    console.log('🔄 Should show discount line?', discount > 0);
  }, [autoPayEnabled, paperlessEnabled]);

  // Log on every render
  console.log(
    '🎨 RENDER - currentDiscount:',
    currentDiscount,
    'autoPayEnabled:',
    autoPayEnabled,
    'paperlessEnabled:',
    paperlessEnabled
  );

  return (
    <PageContainer className="reviewCartNode-Container">
      <div id="reviewCartNode-screen" className="reviewCartNode-Container">
        <div className="reviewCartNode-Header">
          <h2>Review Cart</h2>
          <p>
            Please review your order details and select your billing and
            shipping options. Your installation is at no additional cost.
          </p>
        </div>

        <div className="reviewCartNode-Content">
          <div className="reviewCartNode-Details">
            {/* Service Address */}
            <div className="reviewCartNode-Section">
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div className="reviewCartNode-Circle">1</div>
                  <h4>Service Address</h4>
                </div>
                <div
                  className="reviewCartNode-SecondCol"
                  id={ELEMENT_IDS.CHECKOUT_SERVICE_ADDRESS}
                >
                  {mockData.serviceAddress}
                </div>
                {/* <button className="reviewCartNode-IconButton">
                  <MdEdit />
                </button> */}
              </div>
            </div>

            {/* Mailing Address */}
            <div className="reviewCartNode-Section">
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div className="reviewCartNode-Circle">2</div>
                  <h4>Mailing Address</h4>
                </div>
                <div
                  className="reviewCartNode-SecondCol"
                  id={ELEMENT_IDS.CHECKOUT_SHIPPING_ADDRESS}
                >
                  {mockData.mailingAddress}
                </div>
                {/* <button className="reviewCartNode-IconButton">
                  <MdEdit />
                </button> */}
              </div>
            </div>

            {/* Plan and Packages */}
            <div className="reviewCartNode-Section">
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div className="reviewCartNode-Circle">3</div>
                  <h4>Plan and Packages</h4>
                </div>
                <div className="reviewCartNode-SecondCol">
                  <span className="plan-tag">{mockData.planTag}</span>
                  <strong id={ELEMENT_IDS.CHECKOUT_PLAN_NAME}>
                    {mockData.planName}
                  </strong>
                  <div
                    className="reviewCartNode-Price"
                    id={ELEMENT_IDS.CHECKOUT_PLAN_PRICE}
                  >
                    {mockData.planPrice}/month
                  </div>
                  {/* Installation date removed from main plan */}
                </div>
              </div>

              {/* <hr className="reviewCartNode-Divider" /> */}

              {/* Add-ons */}
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div style={{ width: '32px', height: '32px' }} />
                  <h4>Add-Ons</h4>
                </div>
                <div className="reviewCartNode-SecondCol">
                  <strong id={ELEMENT_IDS.CHECKOUT_ADDON_NAME}>
                    {mockData.addonName}
                  </strong>
                  <div
                    className="reviewCartNode-Price"
                    id={ELEMENT_IDS.CHECKOUT_ADDON_PRICE}
                  >
                    {mockData.addonPrice}/month
                  </div>
                  <div>
                    <div
                      id={ELEMENT_IDS.CHECKOUT_ADDON_INSTALL_DATE}
                      style={{
                        backgroundColor: '#e8f5e8',
                        padding: '12px',
                        borderRadius: '8px',
                        color: '#2d5a2d',
                        fontSize: '14px',
                        marginTop: '8px',
                      }}
                    >
                      {mockData.installDate}
                      <button
                        className="reviewCartNode-IconButton"
                        style={{
                          // display: 'none',
                        }}
                      >
                        <MdEdit />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Billing Preferences */}
            <div className="reviewCartNode-Section">
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div className="reviewCartNode-Circle">4</div>
                  <h4>Billing Preferences</h4>
                </div>
                <div className="reviewCartNode-SecondCol">
                  <strong>Auto Pay</strong>
                  <p>
                    Enroll in autopay to get your $5/mo discount on internet
                    reflected in the advertised price.
                  </p>
                  <div className="reviewCartNode-RadioGroup">
                    <label>
                      <input
                        type="radio"
                        name="autopay"
                        id={ELEMENT_IDS.AUTOPAY_YES}
                        value="yes"
                        checked={autoPayEnabled}
                        onChange={handleAutoPayChange}
                      />
                      &nbsp; Yes, I would like to enroll in Auto Pay
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="autopay"
                        id={ELEMENT_IDS.AUTOPAY_NO}
                        value="no"
                        checked={!autoPayEnabled}
                        onChange={handleAutoPayChange}
                      />{' '}
                      &nbsp; No, I do not want to enroll Auto Pay
                    </label>
                  </div>

                  <strong>Go Paperless</strong>
                  <p>
                    Select how you would like to be notified of your billing
                    statements each month.
                  </p>
                  <div className="reviewCartNode-RadioGroup">
                    <label>
                      <input
                        type="radio"
                        name="paperless"
                        id={ELEMENT_IDS.PAPERLESS_YES}
                        value="yes"
                        checked={paperlessEnabled}
                        onChange={handlePaperlessChange}
                      />
                      &nbsp; Paperless (Auto Pay required)
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="paperless"
                        value="no"
                        id={ELEMENT_IDS.PAPERLESS_NO}
                        checked={!paperlessEnabled}
                        onChange={handlePaperlessChange}
                      />
                      &nbsp; Paper Billing
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Order Summary */}
          <div className="reviewCartNode-OrderSummaryContainer">
            <div className="reviewCartNode-OrderSummary">
              <div className="reviewCartNode-SummaryHeader">
                <h4>Order Summary</h4>
                <span className="reviewCartNode-ItemCount">(2 items)</span>
              </div>

              <div className="reviewCartNode-SummaryDetails">
                <div className="reviewCartNode-SummaryItem">
                  <span id={ELEMENT_IDS.CHECKOUT_PLAN_NAME_SUMMARY}>
                    Plan ({mockData.planName})
                  </span>
                  <span id={ELEMENT_IDS.CHECKOUT_PLAN_PRICE_SUMMARY}>
                    {mockData.planPrice}
                  </span>
                </div>
                <div
                  className="reviewCartNode-SummaryItem"
                  id="addon-summary-item"
                  style={{ display: 'none' }}
                >
                  <span id={ELEMENT_IDS.CHECKOUT_ADDON_NAME_SUMMARY}>
                    WI-FI Mesh Extender
                  </span>
                  <span id={ELEMENT_IDS.CHECKOUT_ADDON_PRICE_SUMMARY}>
                    $3.95
                  </span>
                </div>
                <div className="reviewCartNode-SummaryItem">
                  <span>Modem Rental</span>
                  <span id={ELEMENT_IDS.CHECKOUT_MODEM_RENTAL}>
                    {mockData.modemRental}
                  </span>
                </div>
                <div className="reviewCartNode-SummaryItem reviewCartNode-InstallationFee">
                  <span>Installation</span>
                  <span style={{ color: 'green' }}>$0.00</span>
                </div>
                {/* Only show discount line if discount > 0 */}
                {currentDiscount > 0 ? (
                  <div
                    className="reviewCartNode-SummaryItem"
                    key="discount-item"
                  >
                    <span>Discounts</span>
                    <span
                      id={ELEMENT_IDS.CHECKOUT_DISCOUNT}
                      style={{ color: 'green' }}
                    >
                      -${currentDiscount.toFixed(2)}
                    </span>
                  </div>
                ) : null}
              </div>

              {/* Discount note - Always show to inform users */}
              <p className="reviewCartNode-DiscountNote">
                {autoPayEnabled && paperlessEnabled ? (
                  <>✓ Discounts applied for AutoPay and Paperless Billing</>
                ) : autoPayEnabled ? (
                  <>
                    ✓ Discount applied for AutoPay. Enable Paperless Billing for
                    additional <strong>$5</strong> discount
                  </>
                ) : paperlessEnabled ? (
                  <>
                    ✓ Discount applied for Paperless Billing. Enable AutoPay for
                    additional <strong>$5</strong> discount
                  </>
                ) : (
                  <>
                    💡 Enable AutoPay and Paperless Billing to save{' '}
                    <strong>$10/month</strong>
                  </>
                )}
              </p>

              <div className="reviewCartNode-OrderTotal">
                <span>Order Total*</span>
                <span id={ELEMENT_IDS.CHECKOUT_ORDER_TOTAL}>
                  $
                  {(() => {
                    const planPrice = parseFloat(
                      mockData.planPrice.replace('$', '')
                    );
                    const modemRental = parseFloat(
                      mockData.modemRental.replace('$', '')
                    );
                    const total = planPrice + modemRental - currentDiscount;
                    return total.toFixed(2);
                  })()}
                </span>
              </div>
              <p className="reviewCartNode-TaxNote">
                * Taxes and regulatory fees are not included under the Order
                Total
              </p>
              <Button
                customId={ELEMENT_IDS.CHECKOUT_PROCEED_BUTTON}
                label="Proceed"
                right={<span className="reviewCartNode-PsnArrow">→</span>}
                fullWidth
                onClick={() => {
                  console.log('Proceed to next step');
                  if (onProceedToTerms) {
                    onProceedToTerms();
                  }
                }}
              />
            </div>
            <div className="reviewCartNode-HelpText">
              Need help with your order? <strong>Call 843-538-2020</strong>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default ReviewCartDefault;
